import React from "react";
import PropTypes from "prop-types";
import { Box, List, Typography, useTheme } from "@mui/material";
import IngredientButton from "../Buttons/IngredientButton";
import { validIngredientTaskTypes } from "../../constants";
import validateTasks from "../../Validation/TaskValidation";
import { LocalGroceryStoreOutlined } from "@mui/icons-material";

export default function TaskList({ tasks, setTasks, isAuthor, fromViewPage }) {
  const theme = useTheme(); // Access the theme

  const ingredientTasks = tasks?.filter((task) =>
    validIngredientTaskTypes?.includes(task.type)
  );

  return (
    <Box
      sx={{
        padding: 2,
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.background.default
            : theme.palette.background.paper, // Use theme background color for dark/light mode
        borderRadius: "10px",
        boxShadow: theme.shadows[3], // Use theme shadow
      }}
    >
      <Typography variant="h5" gutterBottom sx={{
        color: 'primary.main',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        '&:after': {
          content: '""',
          flex: 1,
          height: '2px',
          bgcolor: 'divider',
          ml: 2
        }
      }}>
        <LocalGroceryStoreOutlined fontSize="large" />
        Ingredients
      </Typography>
      <List
        sx={{
          padding: 0,
          margin: 0,
        }}
      >
        {ingredientTasks.length === 0 ? (
          <Typography variant="body2" color={theme.palette.text.secondary}>
            No ingredients added yet.
          </Typography>
        ) : (
          ingredientTasks.map((task) => {
            
            return (
              <IngredientButton
                key={task.id}
                task={task}
                onUpdate={(t) => {
                  // eslint-disable-next-line react/prop-types
                  return setTasks(
                    validateTasks(tasks.map((s) => (s.id === t.id ? t : s)))
                  );
                }}
                isAuthor={isAuthor}
                fromViewPage={fromViewPage || false}
              />
            );
          })
        )}
      </List>
      </Box>
  );
}

TaskList.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      type: PropTypes.string.isRequired,
      args: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      item_name: PropTypes.string,
      quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      unit: PropTypes.string,

    })
  ).isRequired,
  setTasks: PropTypes.func.isRequired,
  isAuthor: PropTypes.bool,
  fromViewPage: PropTypes.bool,
};
